import angular from "angular";
import { vsName as reportingModuleName } from "../../reporting";

import {
  vsServiceName as contractServiceName,
  vsProviderName as contractServiceProviderName,
  ContractServiceProvider,
  ContractServiceRun,
} from "./ContractService";

export const vsModuleName = "SlotTrak.Contract.Shared";

angular
  .module(vsModuleName, [reportingModuleName, "ui.router"])
  .provider(contractServiceName, ContractServiceProvider)
  .run(ContractServiceRun);
